import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Divider,
	Grid,
	LinearProgress, makeStyles, TextField
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack'
import { useActions, useValues } from 'kea';
import profilelogic from 'src/store/profile';
const useStyles = makeStyles(() => ({
	root: {}
}));

const ProfileDetails = ({ className, ...rest }) => {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();

	const { profile } = useValues(profilelogic);
	const { update } = useActions(profilelogic);

	const [values, setValues] = useState(profile);



	const handleChange = (event) => {
		setValues({
			...values,
			[event.target.name]: event.target.value
		});
	};

	const handleUpdate = async () => {
		let validated = false;
		if (![
			values.title,
			values.first_name,
			values.last_name,
			values.mobile,
			values.job_title
		].includes('')) {
			validated = true;
		}
		if (!validated) {
			enqueueSnackbar('Incorrect details.', { variant: 'error' });
			return;
		}
		update(values);
	}

	return (
		<form
			autoComplete="off"
			noValidate
			className={clsx(classes.root, className)}
			{...rest}
		>
			<Card>
				<CardHeader
					subheader="The information can be edited"
					title="Profile"
				/>
				<Divider />
				<CardContent>
					<Grid
						container
						spacing={3}
					>
						<Grid
							item
							md={4}
							xs={12}
						>
							<TextField
								fullWidth
								// helperText="Please specify the first name"
								label="Title"
								name="title"
								select
								onChange={handleChange}
								value={values.title}
								variant="outlined"
							>
								<MenuItem
									key={'Mr'}
									value={'Mr'}
								>
									Mr
								</MenuItem>
								<MenuItem
									key={'Mrs'}
									value={'Mrs'}
								>
									Mrs
								</MenuItem>
								<MenuItem
									key={'Miss'}
									value={'Miss'}
								>
									Miss
								</MenuItem>
								<MenuItem
									key={'Mister'}
									value={'Mister'}
								>
									Mister
								</MenuItem>
								<MenuItem
									key={'Other'}
									value={'Other'}
								>
									Other
								</MenuItem>
							</TextField>
						</Grid>
						<Grid
							item
							md={4}
							xs={12}
						>
							<TextField
								fullWidth
								// helperText="Please specify the first name"
								label="First name"
								name="first_name"
								onChange={handleChange}
								error={values.first_name ? false : true}
								helperText={values.first_name ? null : 'Please enter a First Name'}
								value={values.first_name}
								variant="outlined"
								inputProps={{
									maxLength: 100
								}}
							/>
						</Grid>
						<Grid
							item
							md={4}
							xs={12}
						>
							<TextField
								fullWidth
								label="Last name"
								name="last_name"
								onChange={handleChange}
								error={values.last_name ? false : true}
								helperText={values.last_name ? null : 'Please enter a Last Name'}
								value={values.last_name}
								variant="outlined"
								inputProps={{
									maxLength: 100
								}}
							/>
						</Grid>
					</Grid>
				</CardContent>
				<Divider />
				<Box
					display="flex"
					justifyContent="flex-end"
					p={2}
				>
					<Button
						color="primary"
						variant="outlined"
						onClick={handleUpdate}
					>
						Save
					</Button>
				</Box>
			</Card>
		</form>
	);
};

ProfileDetails.propTypes = {
	className: PropTypes.string
};

export default ProfileDetails;
